import view from "../../views/play.js";
import { router } from "../router/index.routes.js";
import { _user, _handler } from "../classes/index.classes.js";
import KTAPI from "../api/index.api.js";
import { ioSocket } from "../mm/index.mm.js";

import { errorMsg } from "./offscreen.controller.js";

let play = {
    render: () => {
        
        return view;
    },
    after_render: async () => {
        console.log("playlist rendering");
        
       router.updatePageLinks();
    },
    root: false, 
    rerender: true,
    rendered: false,
    where: '#kt_content'
};


$(document).ready(function(){
    
});

/**
 * 
 *  SOCKET.IO PROCESSESS
 * 
 */

const playSocket = (socket) => {
        
    
};

export { playSocket };



/**
 * 
 *  RENDER FUNCTIONS
 * 
 */




export default play;